import React from "react";
import { bindActionCreators } from "redux";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import CountriesList from "components/menu/master-files/locations/countries-list";
import ProvincesList from "components/menu/master-files/locations/provinces-list";
import CitiesList from "components/menu/master-files/locations/cities-list";
import PrivateRoute from "components/common/PrivateRoute";
import { clearAllLocations } from "api/menu/master-files/locations/actions";

class LocationsRouter extends React.Component {
    componentWillUnmount() {
        this.props.clearAllLocations();
    }

    render() {
        return (
            <div className="px-5">
                <Switch>
                    <PrivateRoute
                        exact
                        path={`${this.props.match.url}/`}
                        component={CountriesList}
                    />
                    <PrivateRoute
                        exact
                        path={`${this.props.match.url}/:id/provinces`}
                        component={ProvincesList}
                    />
                    <PrivateRoute
                        exact
                        path={`${this.props.match.url}/provinces/:id/cities`}
                        component={CitiesList}
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToDispatch = dispatch => ({
    clearAllLocations: bindActionCreators(clearAllLocations, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(LocationsRouter);
